/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom";
// import * as Sentry from "@sentry/browser";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

/** Local import */
import { Router } from "react-router";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { store, persistor, history } from "./Redux/store";

/** Importing css modules */
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./assets/stylesheet/animate.css";
import "./assets/stylesheet/datePicker.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/stylesheet/main.css";

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN
// });

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router history={history}>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
